let isIOS: () => boolean = () => {
  const flag = !!navigator.userAgent.match(/ipad|iphone/i);
  if (flag) {
    isIOS = () => true;
  } else {
    isIOS = () => false;
  }
  return flag;
};

/** 判断是否是ios端 */
export const IsIOS = () => isIOS();

let isAndroid: () => boolean = () => {
  const u = navigator.userAgent;
  const isAndroidphone = u.includes('Android') || u.includes('Linux');

  if (isAndroidphone) {
    isAndroid = () => true;
  } else {
    isAndroid = () => false;
  }
  return isAndroidphone;
};

/** 判断是否是安卓端 */
export const IsAndroid = () => isAndroid();

let isPC: () => boolean = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }

  isPC = () => flag;

  return flag;
};

/** 判断是否是PC端 */
export const IsPC = () => isPC();
